import { eachDayOfInterval, format, isValid } from 'date-fns';
import type { Entry } from '../api/hooks/useBadgesAwardsChartData';

// TODO: Should probably have more universal type for `data` so it could be reused for other charts
export const fillWithEmptyDataForChart = (
  data: Entry[],
  startDate?: string,
  endDate?: string
): Entry[] => {
  const firstEntry = data.at(0);
  const lastEntry = data.at(-1);
  if (!firstEntry || !lastEntry) {
    return data;
  }

  const parseDate = (dateStr: string | undefined, fallback: string): Date => {
    const parsedDate = new Date(dateStr || fallback);
    return isValid(parsedDate) ? parsedDate : new Date(fallback);
  };

  const start = parseDate(startDate, firstEntry.date);
  const end = parseDate(endDate, lastEntry.date);

  const allDays = eachDayOfInterval({
    start,
    end,
  });

  // Map each day into an object with `count: 0` if there's no data for that day
  const filledData = allDays.map((day) => {
    const formattedDate = format(day, 'yyyy-MM-dd');

    const existingEntry = data.find((entry) => entry.date === formattedDate);

    return (
      existingEntry || {
        date: formattedDate,
        count: 0,
      }
    );
  });

  return filledData;
};
